import { render, staticRenderFns } from "./musrenbang_opd.vue?vue&type=template&id=6299f59f&"
import script from "./musrenbang_opd.vue?vue&type=script&lang=js&"
export * from "./musrenbang_opd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports